import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stages from '../../../BuildingBlocks/Lines/Stages/Stages';

const useStyles = makeStyles((theme: any) => ({
  timeline: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

export default function Timeline({
  line,
  handleStageUpdate = null,
  addStage = null,
  addOrDeleteError = null,
  className = ' ',
}) {
  const classes = useStyles();
  const [openStockOnHand, setOpenStockOnHand] = useState(false);

  line.stages = line.stages.filter((stage) => !stage.deleted);

  return (
    <div className={classes.timeline + ' ' + className}>
      <Stages
        line={line}
        numColumns={line.stages.length - 1}
        onboarding={true}
        handleStageUpdate={handleStageUpdate}
        addStage={addStage}
        addOrDeleteError={addOrDeleteError}
        openStockOnHand={openStockOnHand}
        setOpenStockOnHand={setOpenStockOnHand}
      />
    </div>
  );
}
